import React, { Component, lazy, Suspense } from "react";
import { injectIntl } from "react-intl";

import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Input,
  Button,
} from "reactstrap";

import { NavLink, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  updateSearchKeyword,
  submitSearchByEnter,
  setSearchContext,
  setMenuLayoutType,
  toggleMenuCollapse,
} from "../../redux/actions";

import {
  menuHiddenBreakpoint,
  searchPath,
  localeOptions,
  isDarkSwitchActive,
  END_POINT,
  END_POINT_SOCKET,
  dashboardPath,
} from "../../constants/defaultValues";

import { MobileMenuIcon, MenuIcon, Setting } from "../../components/svg";
import TopnavNotifications from "./Topnav.Notifications";
import TopnavDarkSwitch from "./Topnav.DarkSwitch";

import {
  DEFAULT_AVATAR,
  getAvatar,
  getDirection,
  setDirection,
} from "../../helpers/Utils";
import createSocket from "../../helpers/createSocket";
import { NotificationManager } from "../../components/common/react-notifications";
import TopnavMessages from "./Topnav.Messages";
import IntlMessages from "../../helpers/IntlMessages";
import axios from "axios";
import { isC, isU } from "../../helpers/Roles";

const AddCustomerModalWrapper = lazy(
  () => import("../pages/customer/AddCustomerModalWrapper"),
);
const AddUserStaffModalWrapper = lazy(
  () => import("../pages/user-staff/AddUserStaffModalWrapper"),
);
const AddStockModalWrapper = lazy(
  () => import("../pages/stock/AddStockModalWrapper"),
);
const AddProductModalWrapper = lazy(
  () => import("../pages/product/AddProductModalWrapper"),
);
const AddCompanyProviderModalWrapper = lazy(
  () => import("../pages/company-provider/AddCompanyProviderModalWrapper"),
);
const AddMoreStockModalWrapper = lazy(
  () => import("../pages/stock/AddMoreStockModalWrapper"),
);
const AddWarehouseImportModalWrapper = lazy(
  () => import("../pages/warehouse-import/AddWarehouseImportModalWrapper"),
);

const getSearchPlaceholder = (context, intl) => {
  const placeholders = {
    dashboard: "topnav.search.placeholder.dashboard",
    product: "topnav.search.placeholder.product",
    stock: "topnav.search.placeholder.stock",
    customer: "topnav.search.placeholder.customer",
    order: "topnav.search.placeholder.order",
    staff: "topnav.search.placeholder.staff",
    promotion: "topnav.search.placeholder.promotion",
    provider: "topnav.search.placeholder.provider",
    cashFlow: "topnav.search.placeholder.cash-flow",
    income: "topnav.search.placeholder.income",
    outcome: "topnav.search.placeholder.outcome",
    treasury: "topnav.search.placeholder.treasury",
    warehouseExport: "topnav.search.placeholder.warehouse_export",
    warehouseImport: "topnav.search.placeholder.warehouse_import",
    warehouseTransfer: "topnav.search.placeholder.warehouse_transfer",
    todo: "topnav.search.placeholder.todo",
  };
  const key = placeholders[context] || "topnav.search.placeholder.default";
  return intl.formatMessage({ id: key });
};

const quickProductInputStyle = {
  borderTop: 0,
  borderLeft: 0,
  borderRight: 0,
  borderBottom: "2px solid #145388",
  borderRadius: 0,
};

class TopNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isInFullScreen: false,
      searchKeyword: "",
      itemMenuRightClickCount: 99,
      companyName:
        localStorage.getItem("companyName") &&
        localStorage.getItem("companyName") != "null"
          ? localStorage.getItem("companyName")
          : localStorage.getItem("username"),
      business_type: "",
      isAddCustomerOpen: false,
      isAddUserStaffOpen: false,
      isAddStockOpen: false,
      isAddProductOpen: false,
      isAddCompanyProviderOpen: false,
      isAddMoreStockOpen: false,
      isAddWarehouseImportOpen: false,
      productSearchStatus: "idle",
      quickProductName: "",
      quickProductPrice: "",
      quickProductIdentifierType: "",
      quickProductIdentifier: "",
      isQuickAddingProduct: false,
    };
    this.socket = createSocket();
    this.productSearchTimeout = null;
    this.productSearchRequestId = 0;
    this.quickProductPopupRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleQuickProductOutsideClick);
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    const parentId = localStorage.getItem("b");
    if (
      parentId &&
      parentId !== "null" &&
      parentId !== localStorage.getItem("user_id")
    ) {
      this.socket.emit("join room", {
        room_id: parentId,
      });
    }

    // Lấy business_type
    this.getBusinessType();

    // alert mp3
    this.socket.on("alert-mp3", () => {
      try {
        let alert = document.getElementById("alert-mp3");
        alert.play();
      } catch (error) {
        console.log("alert mp3 exception");
      }
    });

    // schedule todo
    this.socket.on("alert-todo-noti", (res) => {
      // refresh alert data
      this.socket.emit("refresh-alert-data", {
        user_id: localStorage.getItem("user_id"),
      });

      NotificationManager.info(
        this.props.intl.formatMessage({ id: "topnav.noti.todo.message" }),
        this.props.intl.formatMessage({ id: "topnav.noti.todo.title" }),
        3000,
        null,
        null,
        "filled",
      );
    });

    // Logout
    this.socket.on("logout", () => {
      this.handleLogout();
    });

    // Role
    this.socket.on("update-user-role", (res) => {
      // console.log(res.data);
      localStorage.setItem("roleSettings", JSON.stringify(res.data));
    });

    // alert notification
    this.socket.on("remind-created-orders", (res) => {
      NotificationManager.info(
        this.props.intl.formatMessage({ id: "topnav.noti.order.message" }),
        this.props.intl.formatMessage({ id: "topnav.noti.todo.title" }),
        3000,
        null,
        null,
        "filled",
      );
    });

    this.socket.on("alert-stock-down", (res) => {
      NotificationManager.warning(
        this.props.intl.formatMessage({ id: "topnav.noti.stock_down.message" }),
        this.props.intl.formatMessage({ id: "topnav.noti.stock_down.title" }),
        3000,
        null,
        null,
        "filled",
      );
    });
  }

  componentDidUpdate(prevProps) {
    // Clear search keyword when navigating to Settings or Profile pages
    const currentPath = this.props.history?.location?.pathname || "";
    const prevPath = prevProps.history?.location?.pathname || "";

    if (currentPath !== prevPath) {
      console.log("[TopNav] Route changed:", prevPath, "->", currentPath);
      // When route changes, clear keyword if going to settings/profile pages
      if (
        currentPath.includes("/applications/setting") ||
        currentPath.includes("/applications/profile")
      ) {
        console.log(
          "[TopNav] Clearing keyword, current value:",
          this.props.keyword,
        );
        this.props.updateSearchKeyword("");
      }
    }
  }

  componentWillUnmount() {
    if (this.productSearchTimeout) clearTimeout(this.productSearchTimeout);
    document.removeEventListener(
      "mousedown",
      this.handleQuickProductOutsideClick,
    );
    if (this.socket) this.socket.close();
  }

  handleQuickProductOutsideClick = (event) => {
    if (
      this.state.productSearchStatus === "missing" &&
      this.quickProductPopupRef.current &&
      !this.quickProductPopupRef.current.contains(event.target)
    ) {
      this.productSearchRequestId += 1;
      this.setState({
        productSearchStatus: "idle",
        quickProductName: "",
        quickProductPrice: "",
        quickProductIdentifierType: "",
        quickProductIdentifier: "",
      });
    }
  };

  getBusinessType = async () => {
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(`${END_POINT + "/user/business-type"}`, {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
        },
      });
      this.setState({ business_type: response.data.data });
    } catch (err) {
      console.log("Error fetching business type:", err);
    }
  };

  handleChangeLocale = (locale, direction) => {
    this.props.changeLocale(locale);

    const currentDirection = getDirection().direction;
    if (direction !== currentDirection) {
      setDirection(direction);
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  };
  isInFullScreen = () => {
    return (
      (document.fullscreenElement && document.fullscreenElement !== null) ||
      (document.webkitFullscreenElement &&
        document.webkitFullscreenElement !== null) ||
      (document.mozFullScreenElement &&
        document.mozFullScreenElement !== null) ||
      (document.msFullscreenElement && document.msFullscreenElement !== null)
    );
  };
  handleSearchIconClick = (e) => {
    if (window.innerWidth < menuHiddenBreakpoint) {
      let elem = e.target;
      if (!e.target.classList.contains("search")) {
        if (e.target.parentElement.classList.contains("search")) {
          elem = e.target.parentElement;
        } else if (
          e.target.parentElement.parentElement.classList.contains("search")
        ) {
          elem = e.target.parentElement.parentElement;
        }
      }

      if (elem.classList.contains("mobile-view")) {
        this.search();
        elem.classList.remove("mobile-view");
        this.removeEventsSearch();
      } else {
        elem.classList.add("mobile-view");
        this.addEventsSearch();
        // Focus vào input sau khi mở mobile-view
        setTimeout(() => {
          const searchInput = document.getElementById("searchKeyword");
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      }
    } else {
      this.search();
    }
  };
  addEventsSearch = () => {
    document.addEventListener("click", this.handleDocumentClickSearch, true);
  };
  removeEventsSearch = () => {
    document.removeEventListener("click", this.handleDocumentClickSearch, true);
  };

  handleDocumentClickSearch = (e) => {
    let isSearchClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains("navbar") ||
        e.target.classList.contains("simple-icon-magnifier"))
    ) {
      isSearchClick = true;
      if (e.target.classList.contains("simple-icon-magnifier")) {
        this.search();
      }
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      e.target.parentElement.classList.contains("search")
    ) {
      isSearchClick = true;
    }

    if (!isSearchClick) {
      const input = document.querySelector(".mobile-view");
      if (input && input.classList) input.classList.remove("mobile-view");
      this.removeEventsSearch();
      this.setState({
        searchKeyword: "",
      });
    }
  };
  handleSearchInputChange = (e) => {
    const value = e.target.value;
    // Gọi action creator đã được map vào props để dispatch action
    this.props.updateSearchKeyword(value);

    // Tạm ẩn tính năng hiển thị popup tạo sản phẩm khi tìm kiếm
    /*
    if (this.productSearchTimeout) clearTimeout(this.productSearchTimeout);
    const canQuickAdd =
      isC("product") && ["product", "dashboard"].includes(this.props.context);
    if (!canQuickAdd || !value.trim()) {
      this.productSearchRequestId += 1;
      this.setState({
        productSearchStatus: "idle",
        quickProductName: "",
        quickProductPrice: "",
        quickProductIdentifierType: "",
        quickProductIdentifier: "",
      });
      return;
    }

    const requestId = ++this.productSearchRequestId;
    this.setState({ productSearchStatus: "loading" });
    this.productSearchTimeout = setTimeout(() => {
      this.checkProductExists(value, requestId);
    }, 300);
    */
  };

  checkProductExists = async (keyword, requestId) => {
    const normalizedKeyword = keyword.trim().toLocaleLowerCase("vi");
    try {
      const tokenStr = localStorage.getItem("access_token");
      const response = await axios.get(`${END_POINT}/product/json`, {
        params: { pageSize: 10, currentPage: 1, search: keyword.trim() },
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      const products = response.data?.data || [];
      const exactMatch = products.some((product) =>
        [product?.name, product?.sku, product?.barcode].some(
          (value) =>
            String(value || "")
              .trim()
              .toLocaleLowerCase("vi") === normalizedKeyword,
        ),
      );
      if (
        requestId === this.productSearchRequestId &&
        this.props.keyword.trim() === keyword.trim()
      ) {
        this.setState({
          productSearchStatus: exactMatch ? "found" : "missing",
          quickProductName: "",
          quickProductPrice: "",
          quickProductIdentifierType: "",
          quickProductIdentifier: exactMatch ? "" : keyword.trim(),
        });
      }
    } catch (error) {
      if (requestId === this.productSearchRequestId) {
        this.setState({ productSearchStatus: "idle" });
      }
    }
  };

  selectQuickProductIdentifier = (type) => {
    const identifier =
      this.state.quickProductIdentifier || this.props.keyword.trim();
    this.setState({
      quickProductIdentifierType: type,
      quickProductIdentifier: identifier,
      quickProductName: type === "name" ? identifier : "",
    });
  };

  handleQuickAddProduct = async (event) => {
    event.preventDefault();
    const identifierType = this.state.quickProductIdentifierType;
    const identifier = this.state.quickProductIdentifier.trim();
    const name = this.state.quickProductName.trim();
    const price = Number(this.state.quickProductPrice);
    if (!identifierType) {
      NotificationManager.error("Vui lòng chọn loại thông tin nhập", "", 3000);
      return;
    }
    if (!identifier) {
      NotificationManager.error("Vui lòng nhập giá trị tìm kiếm", "", 3000);
      return;
    }
    if (identifierType === "barcode" && !/^\d{8,13}$/.test(identifier)) {
      NotificationManager.error("Barcode phải gồm 8 đến 13 chữ số", "", 3000);
      return;
    }
    if (!name) {
      NotificationManager.error("Vui lòng nhập tên sản phẩm", "", 3000);
      return;
    }
    if (
      !Number.isFinite(price) ||
      price < 0 ||
      this.state.quickProductPrice === ""
    ) {
      NotificationManager.error("Giá bán không hợp lệ", "", 3000);
      return;
    }

    this.setState({ isQuickAddingProduct: true });
    try {
      const tokenStr = localStorage.getItem("access_token");
      const config = { headers: { Authorization: `Bearer ${tokenStr}` } };
      const categoryResponse = await axios.get(`${END_POINT}/category`, config);
      const uncategorizedName = "Chưa phân loại";
      let category = (categoryResponse.data?.data || []).find(
        (item) =>
          String(item?.label || item?.value || item?.name || "")
            .trim()
            .toLocaleLowerCase("vi") ===
          uncategorizedName.toLocaleLowerCase("vi"),
      );
      if (!category) {
        const createdCategory = await axios.post(
          `${END_POINT}/category`,
          { name: uncategorizedName },
          config,
        );
        category = createdCategory.data?.data;
      }
      if (!category?.id)
        throw new Error("Không thể xác định danh mục sản phẩm");

      await axios.post(
        `${END_POINT}/product`,
        {
          name,
          price,
          category_id: category.id,
          sku: identifierType === "sku" ? identifier : "",
          barcode: identifierType === "barcode" ? identifier : "",
        },
        config,
      );
      NotificationManager.success("Đã thêm sản phẩm", "", 3000);
      this.props.updateSearchKeyword("");
      this.setState({
        productSearchStatus: "idle",
        quickProductName: "",
        quickProductPrice: "",
        quickProductIdentifierType: "",
        quickProductIdentifier: "",
        isQuickAddingProduct: false,
      });
      window.dispatchEvent(new CustomEvent("refresh-product-list"));
    } catch (error) {
      NotificationManager.error(
        error.response?.data?.responseText ||
          error.message ||
          "Không thể thêm sản phẩm",
        "",
        3000,
      );
      this.setState({ isQuickAddingProduct: false });
    }
  };

  // HÀM MỚI: Xử lý sự kiện nhấn phím
  handleKeyDown = (event) => {
    // Nếu phím được nhấn là "Enter"
    if (event.key === "Enter") {
      // Ngăn hành động mặc định của trình duyệt (ví dụ: submit form)
      event.preventDefault();
      console.log("Enter pressed in TopNav!");
      // Dispatch action tín hiệu
      this.props.submitSearchByEnter();
    }
  };

  search = () => {
    // this.props.history.push(searchPath + '/' + this.state.searchKeyword);
    // this.props.history.push(searchPath + '/');
    this.setState({
      searchKeyword: "",
    });
  };

  toggleFullScreen = () => {
    const isInFullScreen = this.isInFullScreen();

    var docElm = document.documentElement;
    if (!isInFullScreen) {
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen();
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen();
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen();
      } else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    this.setState({
      isInFullScreen: !isInFullScreen,
    });
  };

  toggleAddCustomer = () => {
    this.setState({ isAddCustomerOpen: !this.state.isAddCustomerOpen });
  };

  toggleAddUserStaff = () => {
    this.setState({ isAddUserStaffOpen: !this.state.isAddUserStaffOpen });
  };

  toggleAddStock = () => {
    this.setState({ isAddStockOpen: !this.state.isAddStockOpen });
  };

  toggleAddProduct = () => {
    this.setState((prevState) => ({
      isAddProductOpen: !prevState.isAddProductOpen,
    }));
  };

  toggleAddCompanyProvider = () => {
    this.setState({
      isAddCompanyProviderOpen: !this.state.isAddCompanyProviderOpen,
    });
  };

  toggleAddMoreStock = () => {
    this.setState({ isAddMoreStockOpen: !this.state.isAddMoreStockOpen });
  };

  toggleAddWarehouseImport = () => {
    this.setState({
      isAddWarehouseImportOpen: !this.state.isAddWarehouseImportOpen,
    });
  };

  handleLogout = () => {
    this.props.logoutUser(this.props.history);
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    e.preventDefault();

    if (this.props.menuLayoutType === "modern-row") {
      this.props.toggleMenuCollapse(!this.props.menuCollapsed);
      return;
    }

    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    if (menuClickCount > 90) {
      this.props.setContainerClassnames(
        0,
        containerClassnames,
        this.props.selectedMenuHasSubItems,
      );
    } else {
      this.props.setContainerClassnames(
        ++menuClickCount,
        containerClassnames,
        this.props.selectedMenuHasSubItems,
      );
    }
  };

  mobileMenuButtonClick = (e, containerClassnames) => {
    e.preventDefault();
    this.props.clickOnMobileMenu(containerClassnames);
  };

  renderMenuIcon = (e) => {
    const store = window.location.host.split(".")[0];

    if (store === "faq") {
      return "/root/faq/dashboards";
    }
    if (store === "message") {
      return "/root/message/dashboards";
    }
    if (store === "upgrade") {
      return "/root/upgrade/dashboards";
    }
    return "#";
  };

  render() {
    const { containerClassnames, menuClickCount, locale } = this.props;
    // const { keyword } = this.props.search;
    // const { messages } = this.props.intl;
    const store = window.location.host.split(".")[0];
    const pathname = this.props.history.location.pathname;
    const PATH_PROFILE = "/app/applications/profile";
    const PATH_FAQ = "/root/faq/dashboards";
    const PATH_MESSAGE = "/root/message/dashboards";
    const PATH_UPGRADE = "/root/upgrade/dashboards";

    const companyLogo = localStorage.getItem("companyLogo");
    const logoSrc = getAvatar(companyLogo);

    const ROLESETTINGS = localStorage.getItem("roleSettings")
      ? JSON.parse(localStorage.getItem("roleSettings"))
      : null;

    if (store === "faq" && PATH_PROFILE !== pathname && PATH_FAQ !== pathname) {
      return <Redirect to="/root/faq/dashboards" />;
    } else if (
      store === "message" &&
      PATH_PROFILE !== pathname &&
      PATH_MESSAGE !== pathname
    ) {
      return <Redirect to="/root/message/dashboards" />;
    } else if (
      store === "upgrade" &&
      PATH_PROFILE !== pathname &&
      PATH_UPGRADE !== pathname
    ) {
      return <Redirect to="/root/upgrade/dashboards" />;
    } else if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_payment = ROLESETTINGS.find(
        (_role) => _role.role_alias === "table_pending_payment",
      );
      if (typeof find_payment != "undefined") {
        return <Redirect to="/payment" />;
      }
    } else if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_kitchen = ROLESETTINGS.find(
        (_role) => _role.role_alias === "kitchen",
      );
      if (typeof find_kitchen != "undefined") {
        return <Redirect to="/kitchen" />;
      }
    } else if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_cashier = ROLESETTINGS.find(
        (_role) => _role.role_alias === "cashier",
      );
      if (typeof find_cashier != "undefined") {
        return <Redirect to="/cashier" />;
      }
    }

    return (
      <nav
        className="navbar fixed-top"
        style={
          this.props.isCashier
            ? { paddingLeft: "45px", paddingRight: "45px" }
            : {}
        }
      >
        <audio
          id="alert-mp3"
          preload="auto"
          src="/assets/sound/alert.mp3"
        ></audio>
        <div className="d-flex align-items-center navbar-left">
          {store === "faq" || store === "message" || store === "upgrade" ? (
            <>
              <NavLink
                to={this.renderMenuIcon()}
                className="menu-button d-none d-md-block"
              >
                <MenuIcon />
              </NavLink>
              <NavLink
                to={this.renderMenuIcon()}
                className="menu-button-mobile d-xs-block d-sm-block d-md-none"
              >
                <MobileMenuIcon />
              </NavLink>
            </>
          ) : (
            <>
              {/* Ẩn menu hamburger cho cashier */}
              {!this.props.isCashier && (
                <>
                  <NavLink
                    to="#"
                    className="menu-button d-none d-md-block"
                    onClick={(e) =>
                      this.menuButtonClick(
                        e,
                        menuClickCount,
                        containerClassnames,
                      )
                    }
                  >
                    <MenuIcon />
                  </NavLink>
                  <NavLink
                    to="#"
                    className="menu-button-mobile d-xs-block d-sm-block d-md-none"
                    onClick={(e) =>
                      this.mobileMenuButtonClick(e, containerClassnames)
                    }
                  >
                    <MobileMenuIcon />
                  </NavLink>
                </>
              )}
              <div className="d-inline-block mr-2">
                <UncontrolledDropdown className="ml-2">
                  <DropdownToggle
                    caret
                    color="light"
                    size="sm"
                    className="language-button"
                  >
                    <span className="name">{locale.toUpperCase()}</span>
                  </DropdownToggle>
                  <DropdownMenu className="mt-3" right>
                    {localeOptions.map((l) => {
                      return (
                        <DropdownItem
                          onClick={() =>
                            this.handleChangeLocale(l.id, l.direction)
                          }
                          key={l.id}
                        >
                          {l.name}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
              <div className="search">
                <Input
                  name="searchKeyword"
                  id="searchKeyword"
                  autoComplete="off"
                  placeholder={getSearchPlaceholder(
                    this.props.context,
                    this.props.intl,
                  )}
                  value={this.props.keyword}
                  onChange={(e) => this.handleSearchInputChange(e)}
                  onKeyDown={this.handleKeyDown} // Thêm sự kiện keydown
                />
                <span
                  className="search-icon"
                  onClick={(e) => this.handleSearchIconClick(e)}
                >
                  <i className="simple-icon-magnifier" />
                </span>
                {/* Tạm ẩn tính năng hiển thị popup tạo sản phẩm từ ô tìm kiếm */}
                {false && this.state.productSearchStatus === "missing" && (
                  <div
                    ref={this.quickProductPopupRef}
                    className="position-absolute bg-white border rounded shadow p-3"
                    style={{
                      top: "calc(100% + 8px)",
                      left: 0,
                      width: "380px",
                      maxWidth: "calc(100vw - 24px)",
                      zIndex: 1050,
                    }}
                  >
                    <form onSubmit={this.handleQuickAddProduct}>
                      <div className="d-flex align-items-center mb-1">
                        <i className="simple-icon-plus text-primary mr-2" />
                        <strong>Thêm nhanh sản phẩm</strong>
                      </div>
                      <div className="text-muted text-small mb-3">
                        Không tìm thấy kết quả khớp. Bạn đang nhập theo:
                      </div>
                      <div className="btn-group d-flex mb-3" role="group">
                        {[
                          ["name", "Tên sản phẩm"],
                          ["sku", "Mã SKU"],
                          ["barcode", "Barcode"],
                        ].map(([type, label]) => (
                          <Button
                            key={type}
                            type="button"
                            size="sm"
                            color={
                              this.state.quickProductIdentifierType === type
                                ? "primary"
                                : "outline-primary"
                            }
                            className="flex-fill"
                            onClick={() =>
                              this.selectQuickProductIdentifier(type)
                            }
                          >
                            {label}
                          </Button>
                        ))}
                      </div>
                      {this.state.quickProductIdentifierType && (
                        <>
                          <label className="mb-1 text-small font-weight-bold">
                            {this.state.quickProductIdentifierType === "name"
                              ? "Tên sản phẩm"
                              : this.state.quickProductIdentifierType === "sku"
                                ? "Mã SKU"
                                : "Mã Barcode"}
                          </label>
                          <Input
                            autoFocus
                            className="mb-3"
                            style={quickProductInputStyle}
                            value={
                              this.state.quickProductIdentifierType === "name"
                                ? this.state.quickProductName
                                : this.state.quickProductIdentifier
                            }
                            onChange={(event) =>
                              this.state.quickProductIdentifierType === "name"
                                ? this.setState({
                                    quickProductName: event.target.value,
                                    quickProductIdentifier: event.target.value,
                                  })
                                : this.setState({
                                    quickProductIdentifier: event.target.value,
                                  })
                            }
                          />
                          {this.state.quickProductIdentifierType !== "name" && (
                            <>
                              <label className="mb-1 text-small font-weight-bold">
                                Tên sản phẩm
                              </label>
                              <Input
                                className="mb-3"
                                style={quickProductInputStyle}
                                placeholder="Nhập tên sản phẩm"
                                value={this.state.quickProductName}
                                onChange={(event) =>
                                  this.setState({
                                    quickProductName: event.target.value,
                                  })
                                }
                              />
                            </>
                          )}
                          <label className="mb-1 text-small font-weight-bold">
                            Giá bán
                          </label>
                          <Input
                            className="mb-3"
                            style={quickProductInputStyle}
                            type="number"
                            min="0"
                            step="any"
                            placeholder="Nhập giá bán"
                            value={this.state.quickProductPrice}
                            onChange={(event) =>
                              this.setState({
                                quickProductPrice: event.target.value,
                              })
                            }
                          />
                          <Button
                            type="submit"
                            color="primary"
                            block
                            disabled={this.state.isQuickAddingProduct}
                          >
                            {this.state.isQuickAddingProduct
                              ? "Đang thêm..."
                              : "Thêm sản phẩm"}
                          </Button>
                        </>
                      )}
                    </form>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <NavLink className="navbar-logo" to="/app/pages/analytics">
          <span className="logo d-block" />
          {/* <span className='logo-mobile d-block d-xs-none' /> */}
        </NavLink>

        <div className="navbar-right">
          {isDarkSwitchActive && <TopnavDarkSwitch />}
          <div className="header-icons d-inline-block align-middle">
            <TopnavMessages />
            <TopnavNotifications />
            {(isC("product") ||
              isC("company_provider") ||
              isC("customer") ||
              isC("user_staff") ||
              isC("stock") ||
              isU("stock") ||
              isC("warehouseImport")) && (
              <UncontrolledDropdown className="mx-2 d-inline-block">
                <DropdownToggle
                  className="header-icon btn btn-empty p-0"
                  color="empty"
                >
                  <i
                    className={`simple-icon-grid ${
                      pathname.includes("/app/pages/product") ||
                      pathname.includes("/app/pages/company-provider") ||
                      pathname.includes("/app/pages/customer") ||
                      pathname.includes("/app/pages/user-staff") ||
                      pathname.includes("/app/pages/warehouse-import") ||
                      (pathname.includes("/app/pages/stock") &&
                        !pathname.includes("/app/pages/stock-"))
                        ? "text-primary"
                        : ""
                    }`}
                  />
                </DropdownToggle>
                <DropdownMenu className="mt-3" right>
                  {isC("product") && (
                    <DropdownItem
                      onClick={this.toggleAddProduct}
                      className={`text-start ${pathname.includes("/app/pages/product") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="simple-icon-list mr-2" />
                      <span>Tạo sản phẩm</span>
                    </DropdownItem>
                  )}
                  {isC("warehouseImport") && (
                    <DropdownItem
                      onClick={this.toggleAddWarehouseImport}
                      className={`text-start ${pathname.includes("/app/pages/warehouse-import") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="iconsminds-add-file mr-2" />
                      <span>Tạo phiếu nhập nhanh</span>
                    </DropdownItem>
                  )}
                  {isC("company_provider") && (
                    <DropdownItem
                      onClick={this.toggleAddCompanyProvider}
                      className={`text-start ${pathname.includes("/app/pages/company-provider") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="iconsminds-network mr-2" />
                      <span>Tạo Nhà cung cấp</span>
                    </DropdownItem>
                  )}
                  {isC("stock") && (
                    <DropdownItem
                      onClick={this.toggleAddStock}
                      className={`text-start ${pathname.includes("/app/pages/stock") && !pathname.includes("/app/pages/stock-") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="simple-icon-basket mr-2" />
                      <span>Tạo Nguyên liệu</span>
                    </DropdownItem>
                  )}
                  {isU("stock") && (
                    <DropdownItem
                      onClick={this.toggleAddMoreStock}
                      className={`text-start ${pathname.includes("/app/pages/stock") && !pathname.includes("/app/pages/stock-") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="simple-icon-plus mr-2" />
                      <span>Bổ sung nguyên liệu</span>
                    </DropdownItem>
                  )}
                  {isC("customer") && (
                    <DropdownItem
                      onClick={this.toggleAddCustomer}
                      className={`text-start ${pathname.includes("/app/pages/customer") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="simple-icon-heart mr-2" />
                      <span>Tạo Khách hàng</span>
                    </DropdownItem>
                  )}
                  {isC("user_staff") && (
                    <DropdownItem
                      onClick={this.toggleAddUserStaff}
                      className={`text-start ${pathname.includes("/app/pages/user-staff") ? "text-primary font-weight-bold" : ""}`}
                    >
                      <i className="simple-icon-people mr-2" />
                      <span>Tạo Nhân viên</span>
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
            <button
              className="header-icon btn btn-empty d-none d-sm-inline-block"
              type="button"
              id="fullScreenButton"
              onClick={this.toggleFullScreen}
            >
              {this.state.isInFullScreen ? (
                <i className="simple-icon-size-actual d-block" />
              ) : (
                <i className="simple-icon-size-fullscreen d-block" />
              )}
            </button>
          </div>
          <div className="user d-inline-block">
            <UncontrolledDropdown className="dropdown-menu-right">
              <DropdownToggle className="p-0" color="empty">
                <span className="name mr-1">{this.state.companyName}</span>
                <span>
                  <img
                    alt=""
                    src={logoSrc}
                    onError={(event) => {
                      event.target.onerror = null;
                      event.target.src = DEFAULT_AVATAR;
                    }}
                  />
                </span>
              </DropdownToggle>
              <DropdownMenu className="mt-3" right>
                {!this.props.isCashier && (
                  <>
                    <NavLink to="/app/applications/profile">
                      <DropdownItem
                        className="text-center"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <span>
                          <img
                            alt=""
                            src={logoSrc}
                            className="img-account"
                            onError={(event) => {
                              event.target.onerror = null;
                              event.target.src = DEFAULT_AVATAR;
                            }}
                          />
                        </span>
                        <IntlMessages id="topnav.menu.account" />
                      </DropdownItem>
                    </NavLink>

                    <DropdownItem divider />
                    <NavLink to="/cashier/default">
                      <DropdownItem
                        className="text-start"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="iconsminds-cash-register-2 mr-2"></i>
                        <IntlMessages id="topnav.menu.cashier" />
                      </DropdownItem>
                    </NavLink>
                    {(this.state.business_type === "cafe" ||
                      this.state.business_type === "restaurant") && (
                      <NavLink to="/payment/default">
                        <DropdownItem
                          className="text-start"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="iconsminds-business-woman mr-2"></i>
                          <IntlMessages id="topnav.menu.waiter" />
                        </DropdownItem>
                      </NavLink>
                    )}
                    {(this.state.business_type === "cafe" ||
                      this.state.business_type === "restaurant") && (
                      <NavLink to="/kitchen/default">
                        <DropdownItem
                          className="text-start"
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <i className="iconsminds-chef-hat mr-2"></i>
                          <IntlMessages id="topnav.menu.kitchen" />
                        </DropdownItem>
                      </NavLink>
                    )}
                    <DropdownItem divider />
                    <NavLink to="/app/applications/setting">
                      <DropdownItem
                        className="text-start"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <i className="simple-icon-settings mr-2" />
                        <IntlMessages id="topnav.menu.settings" />
                      </DropdownItem>
                    </NavLink>
                    {/* <DropdownItem
                      className="text-start d-flex align-items-center justify-content-between"
                      onClick={this.handleToggleMenuLayout}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center">
                        <i className="iconsminds-split-vertical-2 mr-2" />
                        <span>
                          {this.props.menuLayoutType === "modern-row"
                            ? "Menu: Hàng ngang"
                            : "Menu: Cổ điển"}
                        </span>
                      </div>
                      <span className="badge badge-pill badge-outline-primary ml-2">
                        Đổi
                      </span>
                    </DropdownItem> */}
                    <DropdownItem divider />
                  </>
                )}
                <DropdownItem
                  onClick={() => this.handleLogout()}
                  className="text-danger text-start"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <i className="iconsminds-power-2 mr-2" />
                  <IntlMessages id="topnav.menu.logout" />
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>
        <Suspense fallback={null}>
          {this.state.isAddCustomerOpen && (
            <AddCustomerModalWrapper
              isOpen={this.state.isAddCustomerOpen}
              toggle={this.toggleAddCustomer}
              onSuccess={() => {
                window.dispatchEvent(new CustomEvent("refresh-customer-list"));
              }}
            />
          )}
          {this.state.isAddUserStaffOpen && (
            <AddUserStaffModalWrapper
              isOpen={this.state.isAddUserStaffOpen}
              toggle={this.toggleAddUserStaff}
              onSuccess={() => {
                window.dispatchEvent(
                  new CustomEvent("refresh-user-staff-list"),
                );
              }}
            />
          )}
          {this.state.isAddStockOpen && (
            <AddStockModalWrapper
              isOpen={this.state.isAddStockOpen}
              toggle={this.toggleAddStock}
              onSuccess={() => {
                window.dispatchEvent(new CustomEvent("refresh-stock-list"));
              }}
            />
          )}
          {this.state.isAddProductOpen && (
            <AddProductModalWrapper
              isOpen={this.state.isAddProductOpen}
              toggle={this.toggleAddProduct}
              onSuccess={() => {
                window.dispatchEvent(new CustomEvent("refresh-product-list"));
              }}
            />
          )}
          {this.state.isAddCompanyProviderOpen && (
            <AddCompanyProviderModalWrapper
              isOpen={this.state.isAddCompanyProviderOpen}
              toggle={this.toggleAddCompanyProvider}
              onSuccess={() => {
                window.dispatchEvent(
                  new CustomEvent("refresh-company-provider-list"),
                );
              }}
            />
          )}
          {this.state.isAddMoreStockOpen && (
            <AddMoreStockModalWrapper
              isOpen={this.state.isAddMoreStockOpen}
              toggle={this.toggleAddMoreStock}
              onSuccess={() => {
                window.dispatchEvent(new CustomEvent("refresh-stock-list"));
              }}
            />
          )}
          {this.state.isAddWarehouseImportOpen && (
            <AddWarehouseImportModalWrapper
              isOpen={this.state.isAddWarehouseImportOpen}
              toggle={this.toggleAddWarehouseImport}
              onSuccess={() => {
                window.dispatchEvent(
                  new CustomEvent("refresh-warehouse-import-list"),
                );
                window.dispatchEvent(new CustomEvent("refresh-stock-list"));
              }}
            />
          )}
        </Suspense>
      </nav>
    );
  }
}

const mapStateToProps = ({ menu, settings, searchInput }) => {
  const {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    menuLayoutType,
    menuCollapsed,
  } = menu;
  const { locale } = settings;
  const { keyword, context } = searchInput;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
    menuLayoutType,
    menuCollapsed,
    locale,
    keyword,
    context,
  };
};

const mapDispatchToProps = {
  setContainerClassnames,
  clickOnMobileMenu,
  logoutUser,
  changeLocale,
  updateSearchKeyword,
  submitSearchByEnter,
  setSearchContext,
  setMenuLayoutType,
  toggleMenuCollapse,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(TopNav));
